import { observable, action, decorate } from 'mobx';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                         StoreToolTip                          ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class StoreToolTip {

    afficherToolTip = false;
    coordToolTip    = { x : 0, y : 0};
    contenuToolTip  = null;
    hauteur         = 0;
    largeur         = 0;

    /* -------------------------- */
    /* Fin d'affichage du tooltip */
    /* -------------------------- */
 
    nd ()
    {
      this.loupe(null);
    } 

    /* ---------------------------------- */
    /* Modification du contenu du tooltip */
    /* ---------------------------------- */

    loupe (contenu,e=null) {
    
        this.contenuToolTip = contenu; 
        
        this.afficherToolTip = (contenu !== null);
    
        if (e) this.bouge(e);
      }

      /* --------------------- */
      /* Dimensions du tooltip */
      /* --------------------- */

      majDimensions (hauteur=0,largeur=0){
        this.hauteur = hauteur;
        this.largeur = largeur;
      }

      /* ------------------------- */
      /* Positionnement du tooltip */
      /* ------------------------- */
    
      bouge (e) {

        // console.log ("ToolTip - bouge : e.pageY",e.pageY,"e.clientY = ",e.clientY,"window.innerHeight",window.innerHeight,"this.hauteur",this.hauteur);

        // let y = e.clientY + 22;

        let y = e.pageY + 22;

        // if ( (this.coordToolTip.y + this.hauteur) > window.innerHeight ){
        //   y -= (this.hauteur + 35);
        // }

        if ( (e.clientY + this.hauteur) > window.innerHeight ){
          y -= (this.hauteur + 35);
        }

        // this.coordToolTip.x = e.clientX + 5;
        
        this.coordToolTip.x = e.pageX + 5;
        this.coordToolTip.y = y;
      }
        
      /* ----------------------- */
      /* Comportement du ToolTip */
      /* ----------------------- */
    
      comportementToolTip (contenu) {
    
        return {
          onMouseOver  : (e)=>this.loupe(contenu,e),
          onMouseLeave : (e)=>this.loupe(null),
          onMouseMove  : (e)=>this.bouge(e) 
        }
    
      }    

} // Fin de la classe StoreToolTip   

/* -------------------------- */
/* Définition des observables */
/* -------------------------- */

decorate (StoreToolTip, {
  afficherToolTip : observable, 
  coordToolTip    : observable, 
  loupe           : action,
  bouge           : action
} )


// WEBPACK FOOTER //
// ./src/donnees/StoreToolTip.js